import { tv } from '@change/ds-utils';

export const BodyStyles = tv({
	base: 'bg-[#403A49] object-fill',
	variants: {
		size: {
			small: 'h-[178px] w-[100px]',
			medium: 'h-[356px] w-[200px]',
			large: 'h-[414px] w-[233px]',
		},
	},
});

export const LinkStickerStyles = tv({
	base: 'absolute object-fill',
	variants: {
		size: {
			small: 'right-[35px] top-[134px] h-[11px] w-[30px]',
			medium: 'right-[69px] top-[269px] h-[22px] w-[60px]',
			large: 'right-[80px] top-[311px] h-[27px] w-[71px]',
		},
	},
});
